var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "suggestArea" }, [
    _c(
      "ul",
      { staticClass: "suggestList" },
      _vm._l(_vm.list, function (item) {
        return _c(
          "li",
          {
            key: item.id,
            staticClass: "suggestListItem",
            class: {
              grey: "grey" === item.background,
              dense: _vm.dense,
              isPc: !_vm.isSp,
            },
            on: {
              mousedown: function ($event) {
                return _vm.onClick(item)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }